import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { MiniCta } from '../CtaBlock';
export function Guarantee() {
  return <section className="bg-ink-800 px-4 py-14 sm:px-6 sm:py-20" data-id="element-153" data-mp="20mejdr50f65z">
      <div className="mx-auto max-w-2xl rounded-2xl border border-arc/50 bg-ink-700 p-6 text-center sm:p-9" data-id="element-154" data-mp="24molgspolcfk">
        <ShieldCheckIcon className="mx-auto h-14 w-14 text-arc-light" aria-hidden="true" strokeWidth={1.5} data-id="element-155" data-mp="29e6n7izj3h1l" />
        <p className="mt-3 font-display text-xs font-bold uppercase tracking-[0.2em] text-arc-light" data-id="element-156" data-mp="2ef465xsd4f45">
          🛡️ Provalo per 7 giorni senza rischi
        </p>
        <h2 className="mt-3 font-display text-2xl font-bold uppercase leading-tight text-bone sm:text-4xl" data-id="element-157" data-mp="2oc8uo49okmo4">
          Il tuo acquisto è protetto dalla nostra Garanzia di Soddisfazione di 7 Giorni.
        </h2>
        <p className="mt-4 text-[15px] leading-relaxed text-mute sm:text-lg" data-id="element-158" data-mp="tyhl14rcq2so">
          Consulta i Manuali Maestri, utilizza il sistema e decidi se fa al caso tuo.
        </p>
        <p className="mt-3 text-[15px] leading-relaxed text-mute sm:text-lg" data-id="element-159" data-mp="3slolx6mqge92">
          Se ritieni che il Sistema Maestro di Saldatura™ non sia quello che ti aspettavi,
          contattaci entro 7 giorni e ti rimborseremo il tuo acquisto.
        </p>
        <p className="mt-5 font-display text-lg font-bold uppercase tracking-wide text-bone sm:text-xl" data-id="element-160" data-mp="3itiz0bbc8n0q">
          Nessun rischio. Nessuna procedura complicata.
        </p>
        <p className="mt-1 text-[15px] font-semibold text-arc-light" data-id="element-161" data-mp="feeiq2r1ea34">
          Il rischio non è tuo. Lo assumiamo noi.
        </p>

        <MiniCta label="Provalo senza rischi" data-id="element-162" data-mp="adz8vl5yrkpw" />
      </div>
    </section>;
}